import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import type { Reistijdsortering } from "@/lib/reistijd";

/**
 * One component, not one per screen: ADR-0053 gives the ondersteuner the identical treatment a
 * korps gets, down to this control.
 */
export function ReistijdSortering({
  waarde,
  onKies,
}: {
  waarde: Reistijdsortering;
  onKies: (sortering: Reistijdsortering) => void;
}) {
  const { t } = useTranslation("common");

  return (
    <div className="flex items-center gap-1 text-sm">
      <span className="text-muted-foreground">{t("reistijd.sorteerOp")}</span>
      <Button
        type="button"
        size="sm"
        variant={waarde === "datum" ? "secondary" : "ghost"}
        onClick={() => onKies("datum")}
      >
        {t("reistijd.sorteerDatum")}
      </Button>
      <Button
        type="button"
        size="sm"
        variant={waarde === "reistijd" ? "secondary" : "ghost"}
        onClick={() => onKies("reistijd")}
      >
        {t("reistijd.sorteerReistijd")}
      </Button>
    </div>
  );
}
